const admClientRouter = [
  {
    path: "/clients_list",
    name: "ListClients",
    meta:{
      auth: true,
      translated: "Clientes",
      permission: { act: "read", on: "Client" },
    },
    component: () => import("./pages/ClientList.vue"),
    children: [
      {
        path: ":id",
        name: "ShowClientUsage",
        meta:{
          auth: true,
          translated: "Clientes",
          permission: { act: "read", on: "Client" },
        },
        component: () => import("./components/DialogClientUsage.vue"),
      },
    ]
  },
  
];

export default admClientRouter;
